import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import moment from 'moment';

export const AllTimeStartDateStr = '2021-01-01';

function DateSelect(props) {
  const dateSet = {
    allTime: {
      fromDate: moment(AllTimeStartDateStr).format('YYYYMMDD'),
      toDate:   moment().subtract(1, 'days').format('YYYYMMDD'),
    },
    lastMonth: {
      fromDate: moment().subtract(1, 'months').format('YYYYMMDD'),
      toDate:   moment().subtract(1, 'days').format('YYYYMMDD'),
    },
    lastTwoWeeks: {
      fromDate: moment().subtract(2, 'weeks').format('YYYYMMDD'),
      toDate:   moment().subtract(1, 'days').format('YYYYMMDD'),
    },
    lastWeek: {
      fromDate: moment().subtract(1, 'weeks').format('YYYYMMDD'),
      toDate:   moment().subtract(1, 'days').format('YYYYMMDD'),
    },
  };

  return (
    <div>
      <Select
        styles={{
          menu:      (provided) => ({ ...provided, zIndex: 9999  }),
          container: (base) => ({
            ...base,
          }),
        }}
        value={props.value}
        defaultValue={props.options[0]}
        options={props.options}
        onChange={(value) => {
          const selectedVal = dateSet[value.value];
          props.onChange({ ...selectedVal, option: value });
        }}
      />
    </div>
  );
}

DateSelect.defaultProps = {
  value: null,
};

DateSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })).isRequired,
  onChange: PropTypes.func.isRequired,
  value:    PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
};

export default DateSelect;
